"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotificationPreferences = exports.NOTIFICATION_PREFERENCES_KEY = void 0;
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const ui_platform_http_1 = require("@forto-dev/ui-platform-http");
const translations_1 = require("../../../features/NotificationsSettings/types/translations");
const useFetchNotificationPreferences_1 = require("./useFetchNotificationPreferences");
exports.NOTIFICATION_PREFERENCES_KEY = 'notificationPreferences';
const useNotificationPreferences = () => {
    const snackService = (0, frontend_infra_snack_1.useSnackService)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const fetchNotificationPreferences = (0, useFetchNotificationPreferences_1.useFetchNotificationPreferences)();
    return (0, frontend_infra_reactquery_1.useQuery)({
        queryKey: [exports.NOTIFICATION_PREFERENCES_KEY],
        queryFn: async () => {
            try {
                return await fetchNotificationPreferences();
            }
            catch (error) {
                if (error instanceof ui_platform_http_1.HttpError && error.status === 404) {
                    return Promise.reject(error);
                }
                snackService.showError(translate(translations_1.preferenceErrorTranslations.loadError));
                return Promise.reject(error);
            }
        },
    });
};
exports.useNotificationPreferences = useNotificationPreferences;
//# sourceMappingURL=getNotificationPreferences.js.map